<template>
  <form @submit.prevent="handleSubmit" id="request_create_form" enctype="multipart/form-data">
    <!-- Email Address -->
    

    <!-- First Name -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Request Title/Issue <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="title" name="title" ref="title"
        v-model="form.title" placeholder="Request Title/Issue"  />

    </div>
    <div class="mb-3">
      <label class="form-label form-label-thin">Issue Related <span class="text-danger">*</span></label>
        <select class="form-select form-select-thin" v-model="form.issue_related_to" name="issue_related_to"  ref="related_to">
            <option value="" disabled>Select</option>
            <option value="food safety">Food Safety</option>
            <option value="breakdown">Breakdown</option>
            <option value="other">Other</option>
        </select>
    </div>

    <div class="mb-3" v-if="form.issue_related_to === 'other'" >
      <label class="form-label form-label-thin">Other Issue <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="other_issue_detail" name="other_issue_detail" ref="other_issue_detail"
        v-model="form.description" placeholder="Enter Detail of Other Issue" />
    </div>

    <div class="mb-3">
      <label class="form-label form-label-thin">Priority <span class="text-danger">*</span></label>
        <select class="form-select form-select-thin" v-model="form.priority" name="priority"  ref="priority">
            <option value="" disabled>Select</option>
            <option value="low">🔵 Low</option>
            <option value="medium">🟡 Medium</option>
            <option value="high">🔴 High</option>
        </select>
    </div>

    <!-- iterate locations in select -->
    
        <div class="mb-3">
        <label class="form-label form-label-thin">Location <span class="text-danger">*</span></label>
            <select class="form-select form-select-thin" v-model="form.location" name="location"  ref="location">
                <option value="" disabled>Select</option>
                <option v-for="location in locations" :key="location.id" :value="location.external_id">
                    {{ location.name }}
                </option>
            </select>
        </div>

        <!-- now iterate assets -->
        <div class="mb-3">
        <label class="form-label form-label-thin">Asset (If Any) </label
        >
            <select class="form-select form-select-thin" v-model="form.asset" name="asset"   ref="asset">
                <option value="" disabled>Select</option>
                <option v-for="asset in assets" :key="asset.id" :value="asset.external_id">
                    {{ asset.name }}
                </option>
            </select> 
        </div>

     <div class="mb-3">
      <label class="form-label form-label-thin">Description <span class="text-danger">*</span></label>
      <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
        v-model="form.description" placeholder="Request Description" rows="2"></textarea>

    </div>

    <div class="mb-4">
      <FileUploader v-model:files="form.files" maxFiles="3" 
        :help-text="'Upload vendor-related documents or images. Max 10 files.'" />
    </div>


    <!-- Modal Footer -->
     <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close">
          <i class="fa fa-times"></i> Cancel
        </button>
      <button type="submit" class="btn btn-primary text-light hover-white btn-md form-submit-btn">
        <i class="fa fa-save"></i> Create Request
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import FileUploader from '@/components/FileUploader.vue';

export default {
  name: 'CreateRequest',
  emits: ['created', 'close'],
  components: {
    FileUploader
  },
  data() {
    return {
      form: {
        title: '',
        asset: '',
        location: '',
        priority: '',
        issue_related_to: '',
        other_issue_detail: '',
        description: '',
        files:null
        
      },
      submitting: false,
      locations: [],
      assets: []
    }
  },
  mounted() {
    this.get_locations()
    this.get_assets()
  },
  methods: {


    async handleSubmit() {
      this.submitting = true

      const result = await form_api_submit({
        url: 'wo/request/create',
        method: 'POST',
        data: this.form,
        take_form_data: true,
        curr_form_id: '#request_create_form',
      })

      if (result.success) {
        this.$emit('created')
        this.close()
        this.resetForm()
      }

      this.submitting = false
    },


    async get_locations() {
      this.submitting = true

      const result = await form_api_submit({
        url: 'locations/dropdown',
        method: 'GET',
        data: this.form,
        show_success_toast:false
      })

      if (result.success) {
        this.locations = result.data
      }

    },

    async get_assets() {
      this.submitting = true

      const result = await form_api_submit({
        url: 'asset/dropdown',
        method: 'GET',
        show_success_toast:false
      })

      if (result.success) {
        this.assets = result.data
        // console.log(this.assets);
        // alert(this.assets.length);
      }

    },
    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        name: '',
        description: '',
        head: '',
        members: []
      }
    }
  }
}
</script>